import React from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash.groupby';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT } from 'utils/constants/formats';

const ListByDate = (props) => {
  const {
    items,
    className,
    dateField,
    children,
    reverseOrder,
    avoidOrdering,
    timeZoneField,
  } = props;
  const { t } = useTranslation();

  const addDateToItems = (element) =>
    element.map((item) => {
      return {
        ...item,
        date: moment(item[dateField], moment.ISO_8601)
          .tz(item[timeZoneField])
          .format(DATE_FORMAT),
      };
    });

  const sortByDateField = (array, field) => {
    if (avoidOrdering) return array;

    return array.sort((a, b) => {
      if (moment(a[field]).toDate() === moment(b[field]).toDate()) {
        return a.id - b.id;
      }
      return moment(a[field]).toDate() - moment(b[field]).toDate();
    });
  };

  const renderItems = (group) => {
    return sortByDateField(group).map((item) => {
      return (
        <div
          className="list-by-date__item"
          key={`item-${item.id}`}
          data-testid="list-by-date__item"
        >
          {children({ item, ...props })}
        </div>
      );
    });
  };

  const renderDate = (date) => {
    return moment(date, DATE_FORMAT).calendar(new Date(), {
      sameDay: `[${t('DatesUnits:today')}]`,
      nextDay: `[${t('DatesUnits:tomorrow')}]`,
      nextWeek: DATE_FORMAT,
      lastDay: DATE_FORMAT,
      lastWeek: DATE_FORMAT,
      sameElse: DATE_FORMAT,
    });
  };

  const sortByDate = (array) => {
    if (avoidOrdering) return array;

    return array.sort((a, b) => {
      if (reverseOrder) {
        return (
          moment(b, DATE_FORMAT).toDate() - moment(a, DATE_FORMAT).toDate()
        );
      } else {
        return (
          moment(a, DATE_FORMAT).toDate() - moment(b, DATE_FORMAT).toDate()
        );
      }
    });
  };

  const renderItemsByDate = (elements) => {
    if (elements && elements.length > 0) {
      const itemsWithDate = addDateToItems(elements);
      const grouped = groupBy(itemsWithDate, 'date');
      return sortByDate(Object.keys(grouped)).map((date) => {
        return (
          <div
            className="list-by-date__group"
            key={`group-${date}`}
            data-testid="list-by-date__group"
          >
            <h4 className="list-by-date__title">{`${renderDate(date)} (${
              grouped[date].length
            })`}</h4>
            {renderItems(grouped[date])}
          </div>
        );
      });
    }
    return null;
  };

  return (
    <div className={className} data-testid="list-by-date">
      <div className="list-by-date">{renderItemsByDate(items)}</div>
    </div>
  );
};

ListByDate.defaultProps = {
  className: '',
  reverseOrder: false,
};

ListByDate.propTypes = {
  items: PropTypes.array.isRequired,
  className: PropTypes.string,
  dateField: PropTypes.string.isRequired,
  timeZoneField: PropTypes.string.isRequired,
  reverseOrder: PropTypes.bool,
};

export default ListByDate;
